type NordicLocale = "fi" | "is" | "fo";
type NordicPaths = Record<NordicLocale, string>;

const route = (fi: string, is: string, fo: string): NordicPaths => ({
  fi: `/${fi}`,
  is: `/${is}`,
  fo: `/${fo}`,
});

const pathnames: Record<string, NordicPaths> = {
  "/sammenligning": route("vertailu", "samanburdur", "samanbering"),
  "/how-to-use-qr-codes": route(
    "qr-koodien-kaytto",
    "hvernig-a-ad-nota-qr-koda",
    "hvussu-nytir-tu-qr-kotur"
  ),
  "/shared-photo-album": route(
    "jaettu-valokuva-albumi",
    "sameiginlegt-myndaalbum",
    "felags-myndaalbum"
  ),
  "/blog/what-does-a-wedding-photographer-cost": route(
    "blog/haakuvaajan-hinta",
    "blog/verd-brudkaupsljosmyndara",
    "blog/kostnadur-brudleypsmyndatakari"
  ),
  "/blog/wedding-day-schedule": route(
    "blog/haapaivan-aikataulu",
    "blog/dagskra-brudkaupsdags",
    "blog/tidsaetlan-brudleypsdagur"
  ),
  "/blog/wedding-traditions": route(
    "blog/haaperinteet",
    "blog/brudkaupshefdir",
    "blog/brudleypssidvenjur"
  ),
  "/blog/municipality-wedding": route(
    "blog/siviilivihkiminen",
    "blog/borgaraleg-hjonavigsla",
    "blog/borgarlig-vigsla"
  ),
  "/blog/julefrokost-games": route(
    "blog/pikkujoulupelit",
    "blog/leikir-a-jolahladbordi",
    "blog/jolafrokostspol"
  ),
  "/blog/julefrokost-entertainment": route(
    "blog/pikkujouluohjelma",
    "blog/skemmtun-a-jolahladbordi",
    "blog/jolafrokostundirhald"
  ),
  "/blog/julefrokost-ideas": route(
    "blog/pikkujouluideat",
    "blog/hugmyndir-fyrir-jolahladbord",
    "blog/jolafrokosthugskot"
  ),
  "/julefrokost": route("pikkujoulut", "jolahladbord", "jolafrokostur"),
  "/konfirmation": route("rippijuhlat", "ferming", "konfirmation"),
  "/photowall": route("kuvaseina", "myndaveggur", "myndaveggur"),
  "/blog/konfirmation-ideas": route(
    "blog/rippijuhlaideat",
    "blog/fermingarhugmyndir",
    "blog/konfirmationshugskot"
  ),
  "/blog/konfirmationsfotografering": route(
    "blog/rippikuvaus",
    "blog/fermingarljosmyndun",
    "blog/konfirmationsmyndatoka"
  ),
  "/blog/konfirmationsunderholdning": route(
    "blog/rippijuhlaohjelma",
    "blog/fermingarskemmtun",
    "blog/konfirmationsundirhald"
  ),
  "/blog/konfirmationsdekoration-borddaekning": route(
    "blog/rippijuhlien-koristelu-ja-kattaus",
    "blog/fermingarskreytingar-og-bordhald",
    "blog/konfirmationspryding-og-bordreidsla"
  ),
  "/blog/konfirmationsindbydelser-takkekort": route(
    "blog/rippijuhlakutsut-ja-kiitoskortit",
    "blog/fermingarbodskort-og-thakkarkort",
    "blog/konfirmationsbodskort-og-takkarkort"
  ),
  "/blog/konfirmationsfest-program-taler": route(
    "blog/rippijuhlien-ohjelma-ja-puheet",
    "blog/fermingarveisla-dagskra-og-raedur",
    "blog/konfirmationsveitsla-skra-og-roedur"
  ),
  "/blog/konfirmation-gifts": route(
    "blog/rippilahjat",
    "blog/fermingargjafir",
    "blog/konfirmationsgavor"
  ),
  "/blog/konfirmation-food": route(
    "blog/rippijuhlaruoka",
    "blog/fermingarmatur",
    "blog/konfirmationsmatur"
  ),
  "/blog/konfirmation-music": route(
    "blog/rippijuhlamusiikki",
    "blog/fermingartonlist",
    "blog/konfirmationstonleikur"
  ),
  "/blog/konfirmation-venue": route(
    "blog/rippijuhlapaikka",
    "blog/fermingarstadur",
    "blog/konfirmationsstadur"
  ),
  "/blog/konfirmation-outfit": route(
    "blog/rippijuhla-asu",
    "blog/fermingarfot",
    "blog/konfirmationsklaedi"
  ),
  "/blog/christening-ideas": route(
    "blog/ristiaisideat",
    "blog/skirnarhugmyndir",
    "blog/dopshugskot"
  ),
  "/blog/christening-food": route(
    "blog/ristiaisruoka",
    "blog/skirnarmatur",
    "blog/dopsmatur"
  ),
  "/blog/christening-gifts": route(
    "blog/ristiaislahjat",
    "blog/skirnargjafir",
    "blog/dopsgavor"
  ),
  "/blog/christening-decoration": route(
    "blog/ristiaiskoristeet",
    "blog/skirnarskreytingar",
    "blog/dopspryding"
  ),
  "/blog/christening-photos": route(
    "blog/ristiaiskuvat",
    "blog/skirnarmyndir",
    "blog/dopsmyndir"
  ),
  "/blog/wedding-speech": route(
    "blog/haapuhe",
    "blog/brudkaupsraeda",
    "blog/brudleypsroeda"
  ),
  "/blog/wedding-food": route(
    "blog/haaruoka",
    "blog/brudkaupsmatur",
    "blog/brudleypsmatur"
  ),
  "/blog/wedding-venue": route(
    "blog/haapaikka",
    "blog/brudkaupsstadur",
    "blog/brudleypsstadur"
  ),
  "/blog/wedding-flowers": route(
    "blog/haakukat",
    "blog/brudkaupsblom",
    "blog/brudleypsblomur"
  ),
  "/blog/wedding-gifts": route(
    "blog/haalahjat",
    "blog/brudkaupsgjafir",
    "blog/brudleypsgavor"
  ),
  "/blog/bar-mitzvah-party": route(
    "blog/bar-mitsva-juhlat",
    "blog/bar-mitsva-veisla",
    "blog/bar-mitsva-veitsla"
  ),
  "/blog/bar-mitzvah-food": route(
    "blog/bar-mitsva-ruoka",
    "blog/bar-mitsva-matur",
    "blog/bar-mitsva-matur"
  ),
  "/blog/bar-mitzvah-gifts": route(
    "blog/bar-mitsva-lahjat",
    "blog/bar-mitsva-gjafir",
    "blog/bar-mitsva-gavor"
  ),
  "/blog/bar-mitzvah-decoration": route(
    "blog/bar-mitsva-koristelu",
    "blog/bar-mitsva-skreytingar",
    "blog/bar-mitsva-pryding"
  ),
  "/blog/bar-mitzvah-photos": route(
    "blog/bar-mitsva-kuvat",
    "blog/bar-mitsva-myndir",
    "blog/bar-mitsva-myndir"
  ),
  "/blog/birthday-30": route(
    "blog/30-vuotisjuhlat",
    "blog/30-ara-afmaeli",
    "blog/30-ara-fodsingardagur"
  ),
  "/blog/birthday-40": route(
    "blog/40-vuotisjuhlat",
    "blog/40-ara-afmaeli",
    "blog/40-ara-fodsingardagur"
  ),
  "/blog/birthday-50": route(
    "blog/50-vuotisjuhlat",
    "blog/50-ara-afmaeli",
    "blog/50-ara-fodsingardagur"
  ),
  "/blog/birthday-60": route(
    "blog/60-vuotisjuhlat",
    "blog/60-ara-afmaeli",
    "blog/60-ara-fodsingardagur"
  ),
  "/blog/birthday-milestone": route(
    "blog/merkkipaivasyntymapaivat",
    "blog/afmaelisafangi",
    "blog/fodsingardagsmark"
  ),
  "/barnedab": route("ristiaiset", "skirn", "dopur"),
  "/bar-mitsva": route("bar-mitsva", "bar-mitsva", "bar-mitsva"),
  "/fodselsdag": route("syntymapaiva", "afmaeli", "fodsingardagur"),
};

const eventSlugs = {
  wedding: route("haat", "brudkaup", "brudleyp"),
  birthday: route("syntymapaiva", "afmaeli", "fodsingardagur"),
  "bar-mitzvah": route("bar-mitsva", "bar-mitsva", "bar-mitsva"),
  christening: route("ristiaiset", "skirn", "dopur"),
  konfirmation: route("rippijuhlat", "ferming", "konfirmation"),
} as const;

const featureSlugs = {
  photowall: route("kuvaseina", "myndaveggur", "myndaveggur"),
  "qr-code": route("qr-koodi", "qr-kodi", "qr-kota"),
  "full-quality-uploads": route(
    "alkuperaislaatuiset-kuvat",
    "myndir-i-fullum-gaedum",
    "myndir-i-fullari-godu"
  ),
  "faster-uploads": route(
    "nopea-kuvien-lataus",
    "hratt-myndaupphal",
    "skjot-myndaupphaling"
  ),
  "case-story": route("asiakastarina", "reynslusaga", "kundasoga"),
} as const;

for (const [eventKey, localizedEvents] of Object.entries(eventSlugs)) {
  for (const [featureKey, localizedFeatures] of Object.entries(featureSlugs)) {
    const pathname = `/blog/${eventKey}-${featureKey}`;
    pathnames[pathname] = Object.fromEntries(
      (Object.keys(localizedEvents) as NordicLocale[]).map((locale) => [
        locale,
        `/blog/${localizedEvents[locale].slice(1)}-${localizedFeatures[locale].slice(1)}`,
      ])
    ) as NordicPaths;
  }
}

export const additionalNordicPathnames = pathnames;
